import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      margin-top: -3rem;\n      overflow: hidden;\n\n      ",
        " {\n        margin-top: -6rem;\n      }\n      ",
        " {\n        margin-top: -3rem;\n      }\n      ",
        " {\n        margin-top: -6rem;\n      }\n      ",
        "\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { getLinearGradient } from "../../Theme";
import { Global } from "../../styles";
var getBackground = function(theme, style) {
    return ({
        default: ";",
        gray: /*#__PURE__*/ css("background-color:", theme.color.natural10, ";padding-top:6rem;padding-bottom:6rem;"),
        green: /*#__PURE__*/ css("background-image:", getLinearGradient(theme.gradient.green), ";"),
        mint: /*#__PURE__*/ css("background-image:", getLinearGradient(theme.gradient.mint), ";"),
        orange: /*#__PURE__*/ css("background-image:", getLinearGradient(theme.gradient.orange), ";")
    })[style];
};
var WaveSvg = /*#__PURE__*/ styled("svg", {
    target: "eofxi4q0"
})("width:100%;height:auto;fill:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";");
var FixedWave = /*#__PURE__*/ styled("div", {
    target: "eofxi4q1"
})("position:relative;");
var FixedWaveContent = /*#__PURE__*/ styled("div", {
    target: "eofxi4q2"
})("position:relative;z-index:10;");
var FixedWaveWaves = /*#__PURE__*/ styled("div", {
    target: "eofxi4q3"
})(Global.layoutContainerContent, ";", function(param) {
    var theme = param.theme, backgroundStyle = param.backgroundStyle;
    return backgroundStyle && getBackground(theme, backgroundStyle);
}, ";position:absolute;top:0;left:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-50vw + 50%)" : "0";
}, ";right:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-50vw + 50%)" : "";
}, ";z-index:0;display:flex;flex-direction:column;justify-content:space-between;width:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "" : "100%";
}, ";height:", function(param) {
    var height = param.height;
    return height ? "".concat(height, "px") : "";
}, ";", function(param) {
    var theme = param.theme;
    return theme.mq("xxl");
}, "{left:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-960px + 50%)" : "0";
}, ";right:", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth ? "calc(-960px + 50%)" : "";
}, ";}/* Fix for sub-pixel hairline showing on some systems due to scaled SVG. */\n  &::before{content:'';position:absolute;z-index:-1;width:100%;height:1px;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural0;
}, ";}");
var FixedWaveEnd = /*#__PURE__*/ styled("div", {
    target: "eofxi4q4"
})("& > svg{margin-bottom:-6px;}");
var ScalableWaveSvg = /*#__PURE__*/ css("& > svg{margin-left:calc(-50vw + 50%);margin-right:calc(-50vw + 50%);width:100vw;}");
var ScalableWave = /*#__PURE__*/ styled("div", {
    target: "eofxi4q5"
})(Global.layoutContainerContent, ";", function(param) {
    var theme = param.theme, backgroundStyle = param.backgroundStyle;
    return backgroundStyle && getBackground(theme, backgroundStyle);
}, ";", function(param) {
    var isFullWidth = param.isFullWidth, theme = param.theme;
    if (!isFullWidth) return "";
    return css(_templateObject(), theme.mq("md"), theme.mq("lg"), theme.mq("xl"), ScalableWaveSvg);
}, ";");
var ScalableWaveEnd = /*#__PURE__*/ styled("div", {
    target: "eofxi4q6"
})("margin-bottom:-2rem;", function(param) {
    var theme = param.theme;
    return theme.mq("md");
}, "{margin-bottom:-4.5rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("lg");
}, "{margin-bottom:-1.5rem;}", function(param) {
    var theme = param.theme;
    return theme.mq("xl");
}, "{margin-bottom:-2rem;}", function(param) {
    var isFullWidth = param.isFullWidth;
    return isFullWidth && ScalableWaveSvg;
}, ";");
export { WaveSvg, FixedWave, FixedWaveContent, FixedWaveWaves, FixedWaveEnd, ScalableWave, ScalableWaveEnd };
